import { useContext, useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import AuthContext from "context/auth/authContext";

import { TITLES } from "../constants";

const useProductCodeInlineActions = () => {
    const { isAdminManagerUser } = useContext(AuthContext);

    const [rowData, setRowData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const openDialog = (data: any) => {
        setRowData(data);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setRowData(null);
        setIsOpen(false);
    };

    const inlineActions = [
        {
            title: TITLES.EditProductCode,
            icon: EditIcon,
            clickAction: (data: any) => openDialog(data),
            renderConditions: () => isAdminManagerUser
        }
    ];

    return { inlineActions, rowData, isOpen, closeDialog };
};

export { useProductCodeInlineActions };
